import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { provideMarkdown } from 'ngx-markdown';
import { TaxonomyModule } from '../taxonomy/taxonomy.module';
import { allComponents, publicComponents } from './components/index';

@NgModule({
  declarations: [...allComponents],
  imports: [
    CommonModule,
    FormsModule,
    MarkdownModule,
    ReactiveFormsModule,
    TaxonomyModule,
  ],
  providers: [provideMarkdown()],
  exports: [...publicComponents],
})
export class UIElementsModule {}
